import { notify } from 'components/Notifier';
import { downloadFile } from 'services/apiOperations';
import { ReceptionFilters } from 'types';
import { formatFilterAsQueryParams } from 'utils/filters';

export function downloadReceptions(
  sortingCenterId: string,
  filter: ReceptionFilters,
  t: (m: string) => string,
  setModalVisible: (isVisible: boolean) => void,
): void {
  let url = `/sorting_centers/${sortingCenterId}/receptions/report`;

  const params = new URLSearchParams({
    ...formatFilterAsQueryParams(filter, 'receptionDatetime'),
    sortingCenter: sortingCenterId,
  });

  if (!!params.toString()) {
    url += '?' + params.toString();
  }
  setModalVisible(true);
  downloadFile(url)
    .then(() => {
      setModalVisible(false);
      notify({
        message: t('receptions.export.success'),
        severity: 'success',
      });
    })
    .catch(() => {
      setModalVisible(false);
    });
}
